/**
 * Component for the content header with progress information
 */

import React from 'react'
import { Statistic, Icon } from 'antd'
import { useTranslation } from 'react-i18next'

const ContentHeader = ({
  isGeneratingContent,
  progressStatus
}) => {
  const { t } = useTranslation()

  return (
    <div className="ai-course__table-of-content__header">
      <div className="ai-course__table-of-content__left-header">
        <h1>{t('v3:ai_toc')}</h1>
        <span className="ai-course__table-of-content__note">
          {t('v3:ai_note_topic')}
        </span>
      </div>
      {isGeneratingContent && (
        <div className="ai-course__table-of-content__progress">
          <Statistic
            title={t('v4:ai_generate_content_progress')}
            value={`${progressStatus.totalSubtopicsWithContent} / ${progressStatus.totalSubtopics}`}
            precision={2}
            valueStyle={{ color: '#3f8600' }}
            prefix={<Icon type="loading" />}
            suffix=""
          />
        </div>
      )}
    </div>
  )
}

export default ContentHeader
